import { render, staticRenderFns } from "./BrickAndSubstructurePrintPage2.vue?vue&type=template&id=20e905c0"
import script from "./BrickAndSubstructurePrintPage2.vue?vue&type=script&lang=js"
export * from "./BrickAndSubstructurePrintPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.35_babel-core@7.0.0-bridge.0_@babel+core@7.29._80ed213f6ba743306e514f7b7b6c1c5b/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports